import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Paper from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Paper';
import Button from 'Components/UI/Button';
import Typography from 'Components/UI/Typography';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { openModal } from 'Helpers/ModalHelper';
import modalConsts from 'Consts/ModalNames';
import { buildModalQuery } from 'Consts/ModalQueries';
import { PlayArrow as PlayIcon } from '@material-ui/icons';

const styles = theme => ({
  root: {
    padding: theme.spacing(2),
  },
  name: {
    fontWeight: theme.typography.fontWeightMedium,
  },
  value: {
    padding: theme.spacing(1, 0),
    marginRight: theme.spacing(2),
  },
  exploreThisButton: {
    marginLeft: theme.spacing(-0.5),
  },
  trendLabel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    whiteSpace: 'nowrap',
    fontSize: 'small',
  },
  trendingUp: {
    color: theme.palette.secondary.main,
  },
  trendingUpIcon: {
    transform: 'scale(1.5) rotate(-90deg)',
  },
  trendingDown: {
    color: theme.palette.facet.red,
  },
  trendingDownIcon: {
    transform: 'scale(1.5) rotate(90deg)',
  },
  equal: {
    color: theme.palette.facet.accentBlue3,
  },
});

const FinancialWellnessComponentCard = ({
  className,
  classes,
  financialWellnessCollection,
  resource,
  readOnly,
  showDelta,
}) => {
  const valuesCollection = resource.attr('values');

  const pickIcon = (delta) => {
    if (!delta) return null;
    const deltaToFloat = parseFloat(delta);

    if (deltaToFloat > 0) {
      return (
        <div className={classNames(classes.trendLabel, classes.trendingUp)}>
          <PlayIcon className={classes.trendingUpIcon} />
          {`+${delta}`}
        </div>
      );
    }
    if (deltaToFloat < 0) {
      return (
        <div className={classNames(classes.trendLabel, classes.trendingDown)}>
          <PlayIcon className={classes.trendingDownIcon} />
          {`-${delta}`}
        </div>
      );
    }
    return (
      <span className={classes.equal}>
        {'='}
        <br />
        {'No change'}
      </span>
    );
  };

  return (
    <Paper
      className={classNames(classes.root, className)}
      variant="subtle"
    >
      <Typography
        className={classes.name}
        color="primaryGray"
      >
        {resource.attr('name')}
      </Typography>
      <div className={classes.values}>
        {valuesCollection.resources().list().map((valueResource) => {
          let value = valueResource.attr('value');
          const delta = valueResource.attr('delta');

          if (!value || value.length === 0) {
            value = '-';
          }

          return (
            <div
              key={valueResource.id()}
            >
              <span style={{ display: 'flex' }}>
                <Typography
                  className={classes.value}
                  color="secondary"
                  variant="h1"
                >
                  {value}
                </Typography>

                {showDelta && pickIcon(delta)}
              </span>
              <Typography
                color="primaryGray"
              >
                {valueResource.attr('label')}
              </Typography>
            </div>
          );
        })}
      </div>
      {!readOnly && (
        <Button
          className={classes.exploreThisButton}
          color="primary"
          padding="none"
          size="medium"
          variant="text"
          onClick={() => {
            openModal(buildModalQuery(modalConsts.financialWellnessScoreModal, {
              financialWellnessScoreLink: financialWellnessCollection.link('self').url(),
              componentName: resource.attr('type'),
            }));
          }}
        >
          {'Explore This'}
        </Button>)
      }
    </Paper>
  );
};

FinancialWellnessComponentCard.defaultProps = {
  className: '',
  readOnly: false,
  showDelta: false,
};

FinancialWellnessComponentCard.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  financialWellnessCollection: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
  readOnly: PropTypes.bool,
  showDelta: PropTypes.bool,
};

export default withStyles(styles)(FinancialWellnessComponentCard);
